import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input, OnChanges,
  Output, SimpleChanges
} from '@angular/core'

import { Favorite } from '../../shared/interfaces/resources/favorite.interface'
import { FavoriteService } from '../../shared/services/favorite.service'
import { listAnimation } from './list.animation'
import { FavoriteGroup } from '../../shared/interfaces/resources/favorite-group.interface'
import { IncentiveFamily } from '../../shared/enums/incentive.family'

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
  animations: [listAnimation]
})
export class CartComponent implements OnChanges {
  @Input() favoriteIncentives: Favorite[] = []
  @Input() lastAddedIncentives: Favorite[] = []
  @Input() isCartOpen: boolean

  @Output() onCloseModal: EventEmitter<void> = new EventEmitter()

  favoriteGroups: FavoriteGroup[] = []

  private readonly familyOrder: IncentiveFamily[] = [
    IncentiveFamily.RDTAX,
    IncentiveFamily.IPTAX
  ]

  private readonly familyLabels: Record<IncentiveFamily, string> = {
    [IncentiveFamily.RDTAX]: 'Expenditure-based tax incentives',
    [IncentiveFamily.IPTAX]: 'Income-based tax incentives'
  }

  constructor(
    private elementRef: ElementRef,
    private favoriteService: FavoriteService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['favoriteIncentives']) {
      this.groupFavorites()
    }
  }

  private groupFavorites(): void {
    this.favoriteGroups = this.familyOrder
      .map((family) => {
        const incentives = this.favoriteIncentives.filter(
          (favorite) => favorite.family === family
        )

        return {
          family,
          label: this.familyLabels[family],
          incentives
        }
      })
      .filter((group) => group.incentives.length > 0)
  }

  remove(favorite: Favorite): void {
    this.favoriteService.remove({
      id: favorite.id,
      family: favorite.family}
    )
  }

  removeOldFavorites(): void {
    const oldFavorites = this.favoriteIncentives.filter(
      (favorite) =>
        !this.lastAddedIncentives.some(
          (lastAdded) =>
            lastAdded.id === favorite.id &&
            lastAdded.family === favorite.family
        )
    )

    this.favoriteService.remove(
      oldFavorites.map((favorite) => ({
        id: favorite.id,
        family: favorite.family
      }))
    )
  }

  resetFavorites(): void {
    this.favoriteService.removeAllFavorites()
  }

  @HostListener('document:click', ['$event'])
  clickOut(event: any): void {
    if (
      !this.elementRef.nativeElement.contains(event.target) &&
      event.target.id !== 'my-comparator' &&
      event.target.type !== 'checkbox' &&
      !event.target.className.includes('is-inside-cart')
    ) {
      this.onCloseModal.emit()
    }
  }
}
